export enum Actions {
  new = 'new',
  update = 'update',
  // Intern
  create = 'create',
  view = 'view',
  edit = 'edit',
  history = 'history'
}

export const TYPE_ACTIONS_WORKFLOW = {
  NEW: 'new'
}

export const LABEL_ACTIONS_WORKFLOW = {
  NEW: 'Nueva negociación'
} as const

export const CATLOG_ACTION_WORKFLOW = [
  { value: TYPE_ACTIONS_WORKFLOW.NEW, label: LABEL_ACTIONS_WORKFLOW.NEW }
]
